import CreateUpdateTree from '../pages/categories/CreateUpdateTree.vue';
import TreePage from '@/pages/categories/TreePage';
import CategoryAttributesPage from '@/pages/categories/CategoryAttributesPage.vue';
import CreateUpdateAttribute from '@/pages/categories/CreateUpdateAttribute.vue';

export default [
  {
    path: '/categories',
    name: 'CategoriesTree',
    component: TreePage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/categories/create',
    name: 'CreateCategoriesTree',
    component: CreateUpdateTree,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/categories/update/:id',
    name: 'UpdateCategoriesTree',
    component: CreateUpdateTree,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/category-attributes',
    name: 'CategoryAttributes',
    component: CategoryAttributesPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/category-attributes/update/:id',
    name: 'UpdateCategoryAttribute',
    component: CreateUpdateAttribute,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/category-attributes/create',
    name: 'CreateCategoryAttribute',
    component: CreateUpdateAttribute,
    meta: {
      requiresAuth: true,
    },
  },
];
